import request from '../index'

//获取menu组件中的产品、方案id及名称
export function getMenuList() {
	return request({
		url: '/list',
		method: 'get',
	})
}
